(() => {
  const initializedSections = new Set();
  const awaitingSizeSelectionSections = new Set();

  const runWhenReady = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  const getPromptText = (optionName) => `Select ${optionName || 'Size'}`.toUpperCase();

  const getSectionKey = (productInfo) => productInfo?.dataset.section || productInfo?.dataset.originalSection;

  const getSizeSelector = (productInfo) => productInfo?.querySelector('[data-requires-size-selection="true"]');

  const findProductInfo = (sectionId) =>
    Array.from(document.querySelectorAll('product-info')).find(
      (productInfo) => getSectionKey(productInfo) === sectionId || productInfo.dataset.originalSection === sectionId
    );

  const hasSizeSelection = (productInfo) => {
    const sizeSelector = getSizeSelector(productInfo);
    if (!sizeSelector) return true;

    const checkedRadio = sizeSelector.querySelector('input[type="radio"]:checked');
    const select = sizeSelector.querySelector('select');

    return Boolean(checkedRadio || select?.value);
  };

  const clearRadioSelection = (container) => {
    container.querySelectorAll('input[type="radio"]:checked').forEach((radio) => {
      radio.checked = false;
      radio.defaultChecked = false;
      radio.removeAttribute('checked');
    });
  };

  const clearSelectSelection = (container, promptText) => {
    const select = container.querySelector('select');
    if (!select) return;

    let placeholder = select.querySelector('[data-size-placeholder]');

    if (!placeholder) {
      placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = promptText;
      placeholder.disabled = true;
      placeholder.dataset.sizePlaceholder = 'true';
      select.insertBefore(placeholder, select.firstChild);
    }

    Array.from(select.options).forEach((option) => option.removeAttribute('selected'));
    placeholder.selected = true;
    placeholder.setAttribute('selected', 'selected');
    select.selectedIndex = 0;
  };

  const clearRequiredSizeSelection = (productInfo) => {
    const sectionKey = getSectionKey(productInfo);
    const sizeSelector = getSizeSelector(productInfo);
    const productForm = productInfo.querySelector('product-form');
    const submitButton = productForm?.querySelector('[type="submit"]');
    const submitButtonText = submitButton?.querySelector('span');

    if (!sectionKey || !sizeSelector || !submitButton) return;

    const promptText = getPromptText(sizeSelector.dataset.optionName);

    clearRadioSelection(sizeSelector);
    clearSelectSelection(sizeSelector, promptText);

    const selectedValue = sizeSelector.querySelector('[data-selected-value]');
    if (selectedValue) selectedValue.textContent = '';

    const variantInputSelector = [
      '#product-form-' + productInfo.dataset.section + ' input[name="id"]',
      '#product-form-installment-' + productInfo.dataset.section + ' input[name="id"]',
    ].join(', ');

    productInfo.querySelectorAll(variantInputSelector).forEach((input) => {
      input.value = '';
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    submitButton.setAttribute('disabled', 'disabled');
    if (submitButtonText) submitButtonText.textContent = promptText;

    awaitingSizeSelectionSections.add(sectionKey);
  };

  const initializeRequiredSizeSelection = (productInfo) => {
    const sectionKey = getSectionKey(productInfo);
    if (!sectionKey || initializedSections.has(sectionKey) || !getSizeSelector(productInfo)) return;

    initializedSections.add(sectionKey);
    clearRequiredSizeSelection(productInfo);
  };

  const handleOptionChange = (event) => {
    const productInfo = event.target.closest('product-info');
    const sectionKey = getSectionKey(productInfo);
    if (!productInfo || !sectionKey || !getSizeSelector(productInfo)) return;

    if (event.target.closest('[data-requires-size-selection="true"]')) {
      if (hasSizeSelection(productInfo)) {
        awaitingSizeSelectionSections.delete(sectionKey);
      } else {
        awaitingSizeSelectionSections.add(sectionKey);
      }

      return;
    }

    if (!hasSizeSelection(productInfo)) awaitingSizeSelectionSections.add(sectionKey);
  };

  const handleVariantChange = (event) => {
    const sectionId = event?.data?.sectionId;
    const productInfo = findProductInfo(sectionId);
    const sectionKey = getSectionKey(productInfo);

    if (productInfo && awaitingSizeSelectionSections.has(sectionKey)) {
      clearRequiredSizeSelection(productInfo);
    }
  };

  runWhenReady(() => {
    document.addEventListener('change', handleOptionChange);
    document.addEventListener('product-info:loaded', (event) => initializeRequiredSizeSelection(event.target));

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, handleVariantChange);
    }

    document.querySelectorAll('product-info').forEach(initializeRequiredSizeSelection);
  });
})();
